<template>
  <UserDescriptionList :item="model" />
</template>

<script setup lang="ts">
import { User } from '@infuse/e-connector/user/domain';
import { UserDescriptionList } from '@infuse/e-connector/user/ui';

interface Props {
  model: User;
}
withDefaults(defineProps<Props>(), {});
</script>
